import request from '@aned/request';

export async function getRatio(params) {
  return request('/api/blame/aggregate/ratio', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}

export async function getDetail(params) {
  return request('/api/blame/aggregate/detail', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}

export async function updateFile(params) {
  return request('/api/blame/aggregate/pageFileToUep', {
    // headers: { 'Content-Type': 'multipart/form-data' },
    method: 'upload',
    body: params,
  });
}

export async function aggregateExport(params) {
  return request('/api/blame/aggregate/export', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
export async function getDirectiongetRatio(params) {
  return request('api/blame/aggregate/flowRatio', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
export async function getDirectionDetail(params) {
  return request('api/blame/aggregate/flowDetail', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
export async function drectionAggregateExport(params) {
  return request('api/blame/aggregate/flowDayExport', {
    method: 'POST',
    body: params,
    reqType: 'json',
  });
}
